import { render, staticRenderFns } from "./StaffAssignmentForm.vue?vue&type=template&id=5e577ff6&scoped=true"
import script from "./StaffAssignmentForm.vue?vue&type=script&lang=js"
export * from "./StaffAssignmentForm.vue?vue&type=script&lang=js"
import style0 from "./StaffAssignmentForm.vue?vue&type=style&index=0&id=5e577ff6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e577ff6",
  null
  
)

export default component.exports